import {
  Award, Users, Brain, BarChart3, Layers, Briefcase, Cpu,
  HeartPulse, Truck, ShoppingBag, Leaf, Building2, Zap,
  GraduationCap, Sparkles, Target, ShieldCheck, Eye,
  MessageSquare, ArrowUpRight, Check
} from "lucide-react";

export const CAREERS_HERO = {
  eyebrow: "Careers at Asterisk",
  headline: "Build the Future.",
  headlineSuffix: "With a Company That Has Already Stood the Test of Time.",
  subheadline:
    "Technology moves fast. Careers shouldn't feel fragile. At Asterisk, you join a company that has been transforming businesses since 1988 \u2014 while continuously evolving across ERP, data science, automation, and AI.",
};

export const CAREERS_COMPANY = [
  "36+ years established in Singapore",
  "Microsoft Solutions Partner",
  "Multi-industry solution architects",
  "AI and data innovation practitioners",
  "Trusted by 100+ organisations across Asia",
];

export const CAREERS_WHY = [
  {
    title: "Real Projects. Real Impact.",
    description: "Your work contributes directly to improving how SMEs operate, scale, and innovate. When our solutions go live, businesses transform.",
    items: ["ERP & CRM implementations", "Healthcare finance platforms", "AI automation systems", "Data science dashboards", "ESG & sustainability solutions"],
    icon: Target,
  },
  {
    title: "Innovation With Discipline",
    description: "You will learn how innovation is implemented responsibly \u2014 with governance, architecture, and measurable outcomes.",
    items: ["AI that solves operational bottlenecks", "Data science that improves margins", "Automation that reduces manual errors", "Systems that scale across ASEAN"],
    icon: Sparkles,
  },
  {
    title: "Multi-Domain Exposure",
    description: "Working at Asterisk means understanding how real businesses function \u2014 financially, operationally, strategically.",
    items: ["Healthcare & Long-Term Care", "Logistics & Cold Storage", "Distribution & Retail", "Non-Profit & Grants", "Sustainability & ESG"],
    icon: Layers,
  },
  {
    title: "Mentorship From Practitioners",
    description: "Our consultants bring decades of experience. You learn not just technical skills \u2014 but professional judgement.",
    items: ["Solution Architects", "ERP Consultants", "Data Analysts", "AI Engineers", "Project Managers"],
    icon: Users,
  },
];

export const CAREERS_CULTURE = [
  "Integrity in delivery",
  "Clarity in communication",
  "Discipline in execution",
  "Curiosity in innovation",
  "Responsibility in growth",
];

export const CAREERS_INTERNSHIP_TRACKS = [
  {
    title: "ERP & Business Applications",
    items: ["System configuration", "Financial module testing", "Process documentation", "User training support"],
    icon: Layers,
  },
  {
    title: "Data Science & Analytics",
    items: ["Dashboard development", "Data cleansing", "KPI modelling", "Predictive analysis projects"],
    icon: BarChart3,
  },
  {
    title: "AI Design Factory",
    items: ["AI prototype support", "Document automation testing", "Model evaluation", "Integration assistance"],
    icon: Brain,
  },
  {
    title: "Business & Strategy",
    items: ["Market research", "Industry analysis", "Innovation opportunity mapping", "Client solution proposal support"],
    icon: Briefcase,
  },
];

export const CAREERS_GAINS = [
  "Enterprise-level project exposure",
  "Technical and business hybrid skillsets",
  "Professional communication skills",
  "Confidence in client engagement",
  "A strong foundation for digital transformation careers",
];

export const CAREERS_THRIVES = [
  "Curious about how businesses operate",
  "Analytical in thinking",
  "Structured in execution",
  "Eager to learn",
  "Responsible and accountable",
];

export const CAREERS_ROLES = [
  "ERP / Business Central Consultant",
  "CRM Consultant",
  "Solution Architect",
  "Data Analyst / Data Scientist",
  "AI Engineer",
  "Project Manager",
  "Business Analyst",
  "Technical Support Consultant",
  "Intern \u2014 ERP & Business Applications",
  "Intern \u2014 Data Science & Analytics",
  "Intern \u2014 AI Design Factory",
  "Intern \u2014 Business & Strategy",
  "Other",
];
